module.exports = __webpack_public_path__ + "static/img/thumb.1e24402.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img/thumb.png
// module id = OElL
// module chunks = 0